<template>
  <img :src="getSource()" :alt="getAlt()" :class="getClasses()" />
</template>

<script>

export default {
  name: "LogoSwitch",
  props: {
    source1: {
      type: String,
      required: true,
    },
    source2:{
      type: String,
      required: true,
    },
    altText1: {
      type: String,
      required: false,
      default: 'Image',
    },
    altText2: {
      type: String,
      required: false,
      default: 'Image',
    },
    class1: {
      type: String,
      required: true,
    },
    class2: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      showSecondSource: false,
    };
  },
  mounted(){
    window.addEventListener('scroll',this.scrollFunction);
  },
  beforeUnmount() {
    window.removeEventListener('scroll',this.scrollFunction);
  },
  methods: {
    getSource(){
      return this.showSecondSource ? this.source2 : this.source1;
    },
    getAlt(){
      return this.showSecondSource ? this.altText2 : this.altText1;
    },
    getClasses(){
      return this.showSecondSource ? this.class2 : this.class1;
    },
    scrollFunction() {
      let scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      if (scrollTop > 0) {
        this.showSecondSource = true;
      } else if(scrollTop === 0) {
        this.showSecondSource = false;
      }
    }
  }
}
</script>